"use client";
import SectionTitle from "@components/elements/SectionTitle";
import CategoryProfessionSlider from "@components/slider/CategoryProfessionSlider";
import Link from "next/link";

const CategoryProfession = ({profession, pages}) => {
  const currentPageAide = pages.find(item => item.id === 64);
  const currentPage = pages.find(item => item.id === 69);
  const link = currentPageAide?.seo_permalink + "/" + currentPage?.seo_permalink;

  return (
    <>
      <div className="section-padding pb-0">
        <div className="container">
          <SectionTitle
            style={1}
            title={currentPage?.seo_title}
            subTitle={<Link href={link}>{currentPage?.title}</Link>}
          />
          <div className="category-slider1">
            <CategoryProfessionSlider profession={profession} currentPageAide={currentPageAide}/>
          </div>
        </div>
      </div>
    </>
  );
};

export default CategoryProfession;
